module.exports = __webpack_public_path__ + "img/1569263402.ef4659fd.jpg";